<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
      <template #action>
        <div class="content-container-app overflow-auto">
          <div class="font-bold text-blue-700 mb-1">{{ val.nameSite1 }}</div>
          <div class="font-bold text-blue-700 mb-3 ml-3">{{ val.nameSite2 }}</div>

          <!-- 得意先 -->
          <div class="text-xs font-bold text-gray-700 mb-1">得意先</div>
          <div class="font-bold text-indigo-700 mb-1 ml-3">{{ val.client1 }}</div>
          <div class="font-bold text-indigo-700 mb-3 ml-3">{{ val.client2 }}</div>

          <!-- 物件住所 -->
          <div class="text-xs font-bold text-gray-600 mb-1">物件住所</div>
          <div class="text-sm ml-3">{{ val.address1 }}</div>
          <div class="text-sm mb-3 ml-3">{{ val.address2 }}</div>

          <div>
            <div class="text-xs font-bold text-gray-600">AKBS物件詳細</div>
            <div><a :href="'https://akbs-systems.com/#/buildings/' + siteCode" target="_blank" rel="noopener noreferrer" class="text-sm ml-3 text-blue-700 border-b border-blue-700">https://akbs-systems.com/#/buildings/{{ siteCode }}</a></div>
          </div>

          <div v-if="val.contract&&val.contract.length" class="mt-5 mb-8">
            <div class="text-xs font-bold text-gray-600 mb-1">こちらの物件は契約中のデータがあります。</div>
            <table class="w-full border border-gray-300">
              <thead class="bg-colu">
                <tr class="text-sm text-gray-700">
                  <th scope="col" class="text-left px-2 py-2">発注先</th>
                  <th scope="col" class="text-left px-2">作業内容区分</th>
                  <th scope="col" class="text-left px-2">作業内容</th>
                  <th scope="col" class="px-2">3月</th>
                  <th scope="col" class="px-2">4月</th>
                  <th scope="col" class="px-2">5月</th>
                  <th scope="col" class="px-2">6月</th>
                  <th scope="col" class="px-2">7月</th>
                  <th scope="col" class="px-2">8月</th>
                  <th scope="col" class="px-2">9月</th>
                  <th scope="col" class="px-2">10月</th>
                  <th scope="col" class="px-2">11月</th>
                  <th scope="col" class="px-2">12月</th>
                  <th scope="col" class="px-2">1月</th>
                  <th scope="col" class="px-2">2月</th>
                  <th scope="col" class="px-2">契約日</th>
                  <th scope="col" class="px-2">解約日</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in val.contract" :key="i" :class="setColor(i)">
                  <th scope="row" class="text-left px-2">{{ row.purchase }}</th>
                  <td class="px-2">{{ row.nameKubunWorkContent }}</td>
                  <td class="px-2">{{ row.nameWorkContent }}</td>
                  <td class="text-center px-2">{{ row.work3 }}</td>
                  <td class="text-center px-2">{{ row.work4 }}</td>
                  <td class="text-center px-2">{{ row.work5 }}</td>
                  <td class="text-center px-2">{{ row.work6 }}</td>
                  <td class="text-center px-2">{{ row.work7 }}</td>
                  <td class="text-center px-2">{{ row.work8 }}</td>
                  <td class="text-center px-2">{{ row.work9 }}</td>
                  <td class="text-center px-2">{{ row.work10 }}</td>
                  <td class="text-center px-2">{{ row.work11 }}</td>
                  <td class="text-center px-2">{{ row.work12 }}</td>
                  <td class="text-center px-2">{{ row.work1 }}</td>
                  <td class="text-center px-2">{{ row.work2 }}</td>
                  <td class="text-center px-2">{{ row.dateAgreement }}</td>
                  <td class="text-center px-2">{{ row.dateCancellation }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="m-1">
            <PrimaryButton text="閉じる" size="normal w-full" @click="closedModal()"/>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>

import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as backend from '@libs/backend'

export default {
  components: {
    Modal,
    PrimaryButton,
  },

  props: {
    siteCode: {
      type: String
    },
    open: {
      type: Boolean,
      default: false
    },
    year :{
      type: Number
    }
  },

  data() {
    return {
      val: {}
    }
  },

  watch: {
    open() {
      if (this.open) {
        this.getTarget()
      }
    },
  },

  methods: {
    /**
     * 表示するデータ取得
     */
    async getTarget() {
      if (this.siteCode) {
        // 対象物件の詳細情報取得
        const res = await backend.searchData('akbsTable/getContract', { year: this.year, siteCode: this.siteCode })
        this.val = res.data.data
      }
    },

    /**
     * 背景色設定
     */
    setColor(i) {
      if (i % 2 != 0) {
        return 'bg-blue'
      } else {
        return ''
      }
    },
    
    /**
     * 初期化
     */
    closed() {
      this.val = {}
    },

    closedModal() {
      this.$emit('closed')
      this.closed()
    }

  }
}
</script>
<style scoped>

.bg-colu {
  background: #edecf7;
}

.bg-blue {
  background: rgb(243 247 249);
}
</style>